import { type ClassNameValue, twMerge } from 'tailwind-merge';

export type Size = 'sm' | 'md' | 'lg';
export type SemanticColor = 'primary' | 'danger' | 'default';

// not support object syntax
export function classnames(...classes: ClassNameValue[]) {
  return twMerge(classes);
}

export function getSizeClasses(size: Size) {
  switch (size) {
    case 'sm': {
      return 'h-sm px-sm text-sm gap-sm rounded-sm';
    }
    case 'lg': {
      return 'h-lg px-lg text-lg gap-lg rounded-lg';
    }

    default: {
      return 'h-md px-md text-md gap-md rounded-md';
    }
  }
}

export function getStateClasses() {
  return 'box-border data-[focus-visible=true]:ring-2 disabled:cursor-not-allowed';
}

export function getTextColorClasses(color: SemanticColor) {
  return {
    primary: 'text-primary hover:text-primary-hover active:text-primary-active disabled:text-primary-disabled',
    danger: 'text-danger hover:text-danger-hover active:text-danger-active disabled:text-danger-disabled',
    default: 'text-default hover:text-default-hover active:text-default-active disabled:text-default-disabled',
  }[color];
}

export function getBorderColorClasses(color: SemanticColor) {
  return {
    primary:
      'border border-primary hover:border-primary-hover active:border-primary-active disabled:border-primary-disabled',
    danger:
      'border border-danger hover:border-danger-hover active:border-danger-active disabled:border-danger-disabled',
    default:
      'border border-default hover:border-default-hover active:border-default-active disabled:border-default-disabled',
  }[color];
}

export function getBackgroundColorClasses(color: SemanticColor) {
  return {
    primary: 'bg-primary hover:bg-primary-hover active:bg-primary-active disabled:bg-primary-disabled',
    danger: 'bg-danger hover:bg-danger-hover active:bg-danger-active disabled:bg-danger-disabled',
    default: 'bg-default hover:bg-default-hover active:bg-default-active disabled:bg-default-disabled',
  }[color];
}
